import _ from 'lodash';

export default class Menu {
  constructor({el, trigger} = {}) {
    this.DOM = {
      el: el,
      trigger: trigger
    };
    this.state = {
      isOpen: false
    };

    this.toggle = this.toggle.bind(this);
    this.menu = this.menu.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);

    this.init();
  }

  init() {
    if (!this.DOM.el || !this.DOM.trigger) return;
    setTimeout(() => this.DOM.el.style.display = 'block', 500);
    this.bindEvents();
  }

  bindEvents() {
    this.DOM.trigger.addEventListener('click', this.toggle);
    window.addEventListener('scroll', _.throttle(this.menu, 300));
  }

  menu() {
    let target = document.querySelector('.main');
    let targetRect = target.getBoundingClientRect();
    let headerLogo = document.querySelector('.header__logo');

    if (targetRect.top + window.pageYOffset < window.pageYOffset) {
      this.DOM.trigger.classList.add('active');
      headerLogo.classList.add('active');
    } else {
      this.DOM.trigger.classList.remove('active');
      headerLogo.classList.remove('active');
    }
  }

  toggle() {
    this.state.isOpen ? this.close() : this.open();
  }

  close() {
    this.state.isOpen = false;
    this.DOM.el.classList.remove('is-active');
    this.DOM.trigger.classList.remove('is-active');
  }

  open() {
    this.state.isOpen = true;
    this.DOM.el.classList.add('is-active');
    this.DOM.trigger.classList.add('is-active');
  }
}


